/*
 * Project: fuse-react-app
 * FilePath: /src/client/app.jsx
 * File: app.jsx
 * Created Date: Monday, January 21st 2019, 1:59:57 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Feb 13 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Router } from 'react-router-dom'

import { FuseLayout, FuseTheme, FuseAuthorization } from 'modules/@fuse'
import { routes } from 'client/fuse-configs/fuseRoutesConfig'
import MainToolbar from 'client/app/MainToolbar'
import MainNavbarContent from 'client/app/MainNavbarContent'
import MainNavbarHeader from 'client/app/MainNavbarHeader'
import MainFooter from 'client/app/MainFooter'
import QuickPanel from 'client/app/quickPanel/QuickPanel'

import './react-table-defaults'
import history from './history'
import { Auth } from 'modules/auth'

import { withMultipleReducers } from 'modules/@fuse/store/withReducer'
import appReducer from 'client/app/store/reducers'
import projectReducer from 'client/app/sectors/ProjectList/store/reducers'

import * as Actions from './app/store/actions'
import * as MessageActions from 'modules/@fuse/store/actions'

import { Typography, LinearProgress } from '@material-ui/core'
import './styles/index.css'

export class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true, // * Flag holds loading state until resolveApp returns
      errorFound: false
    }
  }

  /**
   * Main App bootstrap request
   * - call API `resolveApp` endpoint
   * - populates redux->globalAppData->user|projects
   */
  componentDidMount () {
    const self = this
    const props = self.props

    // TODO - we should have the app resolution response before loading the FuseLayout at least
    // ? Maybe have a loading state visible for main resolveAppData request duration
    props.resolveAppData().then(resp => {
      if (Error.isError(resp)) {
        self.handleError(resp, null)
      } else {
        this.setState({
          loading: false
        })
        props.hide() // reset
        props.show({
          message: 'Successfully obtained App Data',
          autoHideDuration: 3000,
          variant: 'success'
        })
      }
    }).catch(error => {
      self.handleError(error)
    })
  }

  componentDidCatch (error, info) {
    this.handleError(error, info)
  }

  handleError = (error, info) => {
    // console.log('[APP] error: ', error)
    // console.log('[APP] info: ', info)

    this.setState({
      error,
      errorFound: true,
      loading: false
    })
    this.props.hide()
    this.props.show({
      message: error.message || error,
      autoHideDuration: 5000,
      variant: 'error'
    })
  }

  render () {
    const stateLoading = this.state.loading

    const loading = stateLoading && (
      <div className='flex flex-1 flex-col items-center justify-center' style={{ background: '#FAFAFA' }}>
        <Typography className='text-20 mb-16' color='textSecondary'>Loading...</Typography>
        <LinearProgress className='w-xs' color='secondary' />
      </div>
    )
    const appContent = !stateLoading && (
      <FuseLayout
        routes={routes}
        toolbar={
          <MainToolbar />
        }
        navbarHeader={
          <MainNavbarHeader />
        }
        navbarContent={
          <MainNavbarContent />
        }
        footer={
          <MainFooter />
        }
        rightSidePanel={
          <React.Fragment>
            <QuickPanel />
          </React.Fragment>
        }
      />
    )

    const content = stateLoading ? loading : appContent
    return (
      <Auth>
        <Router history={history}>
          <FuseAuthorization routes={routes}>
            <FuseTheme>
              {content}
            </FuseTheme>
          </FuseAuthorization>
        </Router>
      </Auth>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    resolveAppData: Actions.getAppData,
    show: MessageActions.showMessage,
    hide: MessageActions.hideMessage
  }, dispatch)
}

function mapStateToProps (store) {
  return {}
}

export default withMultipleReducers([
  {
    key: 'globalAppData',
    reducer: appReducer
  }, {
    key: 'projects',
    reducer: projectReducer
  }
])(
  connect(mapStateToProps, mapDispatchToProps)(
    App
  )
)
